import { Quelle } from '@/model/quelle.ts';

export interface Haltestelle {
  readonly name: string;
  readonly evaNummer: string;
  readonly rl100: string | null;
}

export interface HaltestelleWithQuelle extends Haltestelle {
  readonly quelle: Quelle;
}

export function getHaltestelleId(haltestelle: HaltestelleWithQuelle): string {
  return `${haltestelle.quelle}#${haltestelle.evaNummer}#${haltestelle.name}`;
}
